<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<p class="tocf"><a href="#/xhtml/intro"><strong>INTRODUCTION</strong></a></p>
<p class="tocf"><span href="#/xhtml/book" title="Link target outside of Sample"><strong>HOW TO USE THIS BOOK</strong></span></p>
<p class="tocchap"><span href="#/xhtml/ch1" title="Link target outside of Sample">1 Choosing Your Materials</span></p>
<p class="tocchap"><span href="#/xhtml/ch2" title="Link target outside of Sample">2 Learning the Basics</span><a epub:type="pagebreak" id="page_7"></a></p><a epub:type="pagebreak" id="page_7">
</a><p class="tocchap"><a epub:type="pagebreak" id="page_7"></a><span href="#/xhtml/ch3" title="Link target outside of Sample">3 Making the Hat</span></p>
<p class="toccs"><span href="#/xhtml/ch3#sec1" title="Link target outside of Sample"><strong>The Pattern</strong></span></p>
<p class="toccss"><span href="#/xhtml/ch3#sec2" title="Link target outside of Sample">Knitting the Brim</span></p>
<p class="toccss"><span href="#/xhtml/ch3#sec3" title="Link target outside of Sample">Knitting the Body</span></p>
<p class="toccss"><span href="#/xhtml/ch3#sec4" title="Link target outside of Sample">Knitting the Top</span></p>
<p class="toccs"><span href="#/xhtml/ch3#sec5" title="Link target outside of Sample"><strong>Modifications</strong></span></p>
<p class="toccss"><span href="#/xhtml/ch3#sec6" title="Link target outside of Sample">Ribbed Brim</span></p>
<p class="toccss"><span href="#/xhtml/ch3#sec7" title="Link target outside of Sample">Stripes</span></p>
<p class="toccss"><span href="#/xhtml/ch3#sec8" title="Link target outside of Sample">Pom-pom</span></p>
<p class="toccst"><span href="#/xhtml/notes" title="Link target outside of Sample">ENDNOTES</span></p>
<p class="toccs"><span href="#/xhtml/resources" title="Link target outside of Sample">OTHER RESOURCES</span></p>
<p class="toccs"><span href="#/xhtml/ack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?17308272